import Api from './api';

const slug = 'v1/scores';
export default {
  getScoreIntervals() {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
